import React from 'react';

interface SwitchToggleProps {
    enabled: boolean;
    onChange: () => void;
    disabled?: boolean;
}

export const SwitchToggle: React.FC<SwitchToggleProps> = ({ enabled, onChange, disabled = false }) => (
    <button
        type="button"
        className={`${enabled ? 'bg-sky-500' : 'bg-gray-300'} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} relative inline-flex items-center h-6 w-11 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-2`}
        onClick={disabled ? undefined : onChange}
        aria-pressed={enabled}
        disabled={disabled}
    >
        <span className="sr-only">Use setting</span>
        <span
            aria-hidden="true"
            className={`${enabled ? 'translate-x-5' : 'translate-x-0'} inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
        />
    </button>
);
